<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'

interface FormState {
  rating: number
  review: string
}
interface PropTypes {
  title?: string
}

withDefaults(defineProps<PropTypes>(), {
  title: null
})

const route = useRoute()

const coursesStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => coursesStore.state?.courseDetail)

const emits = defineEmits(['onFinish'])

const submitLoading = ref<boolean>(false)

const formState = reactive<FormState>({
  rating: null,
  review: null
})

const disbaledButton = computed<boolean>(() => {
  return isEmpty(formState.rating) && isEmpty(formState.review)
})

const onOkForm = () => {
  submitLoading.value = true
  coursesStore.courseRating({
    payload: {
      ...formState,
      courseSerial:
        courseDetail.value?.data?.serial ?? route?.query?.courseSerial
    },
    resolve: () => {
      submitLoading.value = false
      emits('onFinish')
    }
  })
}
</script>

<template>
  <a-form
    id="form-kursus-materi-rating"
    name="rating-course"
    :model="formState"
    layout="vertical"
    autocomplete="off"
    class="kg-form"
    @finish="onOkForm"
  >
    <a-form-item>
      <div class="flex items-center">
        <img
          src="~/assets/images/course/illustration-rating.svg"
          alt="rating"
          loading="lazy"
        />
        <div class="player-rating-title">
          <template v-if="title">
            {{ title }}
          </template>
          <template v-else>
            Selamat kamu telah menyelesaikan
            {{ courseDetail?.data?.title ?? 'N/A' }} dengan baik! 🎉
          </template>
        </div>
      </div>
    </a-form-item>
    <a-form-item
      name="rate"
      label="Bagaimana pengalaman belajarmu di kelas ini?"
    >
      <a-rate v-model:value="formState.rating" character="★" />
    </a-form-item>
    <a-form-item name="review">
      <a-textarea
        v-model:value="formState.review"
        :rows="4"
        placeholder="Tuliskan ulasan kamu disini"
        min
      />
    </a-form-item>
    <a-form-item>
      <div class="w-full text-right">
        <a-button
          type="primary"
          size="large"
          html-type="submit"
          :disabled="disbaledButton"
          :loading="submitLoading"
        >
          Kirim dan Ambil Sertifikat
        </a-button>
      </div>
    </a-form-item>
  </a-form>
</template>

<style lang="scss">
@use './styles.scss';
</style>
